import axios from "axios";
import qs from "qs";
import { message } from "ant-design-vue";

import { getUrlConfig, storage } from "@/utils";

/**
 * @author xieren
 * @description axios初始化
 */
const instance = axios.create({
  baseURL: getUrlConfig().apiDomain,
  timeout: 15000, // 请求超时时间，设置15秒超时
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

/**
 * @author xieren
 * @description axios请求拦截器
 */
instance.interceptors.request.use(
  (config) => {
    // config.headers["appId"] = 2;
    const token = storage.get("token") || "";
    if (token) {
      config.headers["token"] = token;
    }
    const appId = window.localStorage.getItem("appId") || "";
    if (appId) {
      config.headers["appId"] = appId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * @author xieren
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
  switch (code) {
    case 401: {
      // message.error(msg || "登录失效，请退出重新登录");
      // window.localStorage.clear()
      // window.location.href = `${import.meta.env.VITE_APP_BASE_URL_1}login?next=${encodeURIComponent(
      //   window.location.href
      // )}`;
      break;
    }
    case 403: {
      break;
    }
    // 登录token失效
    case 10003: {
      message.destroy();
      message.error(msg || "token过期，请重新登陆");
      setTimeout(() => {
        storage.clear();
        window.location.replace(`${import.meta.env.VITE_APP_BASE_URL_1}login`);
      }, 1000);
      break;
    }
    case 88888: {
      break;
    }
    default: {
      // message.error(msg || `后端接口${code}异常`);
      break;
    }
  }
};

/**
 * @author xieren
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 操作正常Code数组，code=99999 => ok
    const successCode = [99999];
    // 是否操作正常
    if (successCode.includes(res?.code)) {
      return res;
    } else {
      const { code, msg } = res;
      handleCode(code, msg);
      return Promise.reject(res);
    }
  },
  (error) => {
    if (error?.response) {
      const { status, data } = error.response;
      handleCode(status, data?.msg || error.message);
      return Promise.reject(error.response.data);
    } else {
      let msg = "";
      if (error.message === "Network Error") {
        msg = "后端接口连接异常";
      }
      if (error.message.includes("timeout")) {
        msg = "后端接口请求超时";
      }
      if (error.message.includes("Request failed with status code")) {
        const code = error.message.substr(message.length - 3);
        msg = "后端接口" + code + "异常";
      }
      message.error(msg || `后端接口未知异常`);
      return Promise.reject(error);
    }
  }
);

export default instance;
